module.exports = __webpack_public_path__ + "img/1.b74c299f.jpg";